import { useGSAP } from "@gsap/react";
import { booking } from "../constants";
import { animateWithGsap } from "../utils/animations";
import BookingCalendar from "./BookingCalendar";

const Booking = () => {
  useGSAP(() => {
    animateWithGsap("#rendez-vous .booking-anim", { y: 0, opacity: 1, stagger: 0.1 });
  }, []);

  return (
    <section id="rendez-vous" className="section-padding">
      <div className="section-container">
        <div className="text-center flex flex-col items-center">
          <span className="booking-anim reveal eyebrow">Réservation en ligne</span>
          <h2 className="booking-anim reveal section-title">{booking.title}</h2>
          <p className="booking-anim reveal section-subtitle mx-auto">{booking.subtitle}</p>
        </div>

        {/* ----------------------------------------------------------------- */}
        {/*  CALENDRIER DE RÉSERVATION (démo maquette, sans back-end)         */}
        {/*  Tous les réglages (créneaux, jours fermés...) sont dans          */}
        {/*  src/constants/index.js → objet "booking".                        */}
        {/*                                                                   */}
        {/*  ➜ PASSAGE EN PRODUCTION : pour de vraies réservations avec       */}
        {/*    acompte + notifications, remplace <BookingCalendar/> par :     */}
        {/*    <iframe src={booking.calendlyUrl} className="w-full h-[720px]   */}
        {/*      rounded-xl bg-white" title="Réservation Calendly" />         */}
        {/* ----------------------------------------------------------------- */}
        <div className="booking-anim reveal">
          <BookingCalendar />
        </div>

        <p className="booking-anim reveal mt-4 text-center text-xs text-chrome-dark">
          Un souci pour réserver ? Utilisez le bouton de contact en bas à droite.
        </p>
      </div>
    </section>
  );
};

export default Booking;
